import { CornerSize, emptyObstructionDefaults, Kitchen, Size } from '..';
import { Obstruction } from '../blueprint-classes/obstructions/obstruction.class';

import { EmptyObstructionDefaults } from './empty-obstruction-defaults';

export const newEmptyObstruction = (kitchen: Kitchen, obstructionType: EmptyObstructionDefaults, angle: number, isDefault = false): Obstruction => {
	const details = emptyObstructionDefaults[obstructionType];
	const obstruction = kitchen.design.obstructions.newObstruction(details.type, { width: details.width, height: details.height, depth: details.depth } as (Size | CornerSize));

	if (isDefault) kitchen.design.islands.setDefaultIsland(obstruction.id);
	obstruction.axis.y = angle;

	return obstruction;
};
